import {
  gramToKg,
  gramToPound,
  MIN_KG_BODY_WEIGHT,
  MAX_KG_BODY_WEIGHT,
  MIN_LB_BODY_WEIGHT,
  MAX_LB_BODY_WEIGHT,
} from "./weightConverter"
import { roundByDecimalPlace } from "utils"
import { IBodyDisplayUnits } from "features/profile/profileTypes"

const validateMetricWeight = (gramWeight: number) => {
  const kgWeight = roundByDecimalPlace(gramToKg(gramWeight), 1)

  if (kgWeight < MIN_KG_BODY_WEIGHT || kgWeight > MAX_KG_BODY_WEIGHT) {
    return `Weight must be between ${MIN_KG_BODY_WEIGHT},0 kg and ${MAX_KG_BODY_WEIGHT},0 kg.`
  }

  return ""
}

const validateImperialWeight = (gramWeight: number) => {
  const poundWeight = roundByDecimalPlace(gramToPound(gramWeight), 1)

  if (poundWeight < MIN_LB_BODY_WEIGHT || poundWeight > MAX_LB_BODY_WEIGHT) {
    return `Weight must be between ${MIN_LB_BODY_WEIGHT},0 lb and ${MAX_LB_BODY_WEIGHT},0 lb.`
  }

  return ""
}

export const validateBodyWeight = (
  bodyDisplayUnits: IBodyDisplayUnits,
  gramWeight: number,
) => {
  return bodyDisplayUnits === "METRIC"
    ? validateMetricWeight(gramWeight)
    : validateImperialWeight(gramWeight)
}

const GOAL_WEIGHT_PROXIMITY_SERVER_ERROR =
  "Goal weight is too far from current weight"

export const isGoalWeightProximityError = (error: any): boolean => {
  const message = error?.response?.data?.message ?? error?.message ?? ""
  return (
    typeof message === "string" &&
    message.startsWith(GOAL_WEIGHT_PROXIMITY_SERVER_ERROR)
  )
}
